import { render } from "./GuideErrors.vue?vue&type=template&id=8bc70a60"
import script from "./GuideErrors.vue?vue&type=script&lang=js"
export * from "./GuideErrors.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator,QMarkupTable,QBanner,QIcon});
